import { validator } from "LIB/validate-this";
import { get } from "lodash";
import * as rules from "LIB/validation/rules";
import {
  validateShippingFields,
  validateConditionFields,
  validatePurchaseForFields,
  validatePurchaseForSaleFields
} from "MODULES/PurchaseOrders/shared/validations";
import {
  AS_REMOVED,
  BUYING_STORE_ID,
  CORE_REPAIR_FEE_NOT_TO_EXCEED,
  HAZMAT_FEE,
  PAYMENT_TERMS,
  PREFERRED_REPAIR_STATION_ID,
  RESERVE_FOR_SALE_QUANTITY,
  TOOL_USED
} from "MODULES/PurchaseOrders/constants";
import {
  CONDITION,
  EXCHANGE_SRP,
  LEAD_TIME,
  NEW_ITEM,
  SRP_CONDITION,
  SUGGESTED_RETAIL,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { DOM } from "MODULES/parts/constants";
import {
  BUYER_CREDIT_PCT,
  COST,
  FOB,
  LINE_ITEMS,
  QUANTITY
} from "APP_ROOT/constants";
import { PURCHASE_STATUS } from "MODULES/IncomingQuotes/constants";
import {
  CORE_DUE_DAYS,
  CORE_RETURN_DATE
} from "MODULES/RepairOrders/constants";
import { EXCHANGE_FEE } from "MODULES/OutgoingQuotes/constants";
import { TAG_DATE_CONDITIONS } from "MODULES/Receiving/constants";
import { useSettings } from "APP_ROOT/hooks/useCurrentUser";

const validateLineItem = props => (item, itemValues) => {
  if (!itemValues.included) {
    return;
  }

  item
    .validate(CONDITION, QUANTITY, COST, PURCHASE_STATUS, TOOL_USED)
    .satisfies(rules.required);

  item.validate(LEAD_TIME).satisfies(rules.requiredAllowZero);

  if (TAG_DATE_CONDITIONS.includes(itemValues.condition)) {
    item.validate(TAGGED_BY).satisfies(rules.required);
  }

  if (itemValues.hazmat) {
    item
      .validate(HAZMAT_FEE)
      .satisfies(rules.required, rules.isGreaterThanOrEqualTo(0));
  }

  if (
    !(
      itemValues.purchase_for_sale &&
      Number(itemValues.quantity) ===
        Number(itemValues[RESERVE_FOR_SALE_QUANTITY])
    )
  ) {
    item.validate(SRP_CONDITION, SUGGESTED_RETAIL).satisfies(rules.required);

    if (
      !get(itemValues, "part.pass_fail") &&
      ![AS_REMOVED, NEW_ITEM].includes(itemValues.condition) &&
      !itemValues.do_not_exchange
    ) {
      const minOutrightValueForExchangeSettings = useSettings()
        .min_outright_value_for_exchange_consideration;
      const suggestedRetail = parseFloat(itemValues.suggested_retail);
      const minOutrightValue = parseFloat(minOutrightValueForExchangeSettings);
      const shouldCheckMinValue =
        minOutrightValueForExchangeSettings !== null &&
        minOutrightValueForExchangeSettings !== undefined;

      if (!shouldCheckMinValue || suggestedRetail >= minOutrightValue) {
        item
          .validate(EXCHANGE_SRP)
          .satisfies(rules.required, rules.isGreaterThan(0));
      }
    }
  }

  if (itemValues.purchase_for_stock) {
    item.validate(SRP_CONDITION).satisfies(rules.matches(CONDITION));
  }

  if (get(itemValues, "part.dom_life_years") && get(itemValues, "part.llp")) {
    item.validate(DOM).satisfies(rules.required);
  }

  if (
    itemValues.purchase_for_repair ||
    (itemValues.condition === AS_REMOVED &&
      !itemValues.purchase_for_sale &&
      !itemValues.purchase_for_stock)
  ) {
    item.validate(PREFERRED_REPAIR_STATION_ID).satisfies(rules.required);
  }

  if (itemValues.purchase_for_exchange) {
    item.validate(CORE_DUE_DAYS, CORE_RETURN_DATE).satisfies(rules.required);
    item.validate(QUANTITY).satisfies(rules.mustBeOne);

    if (!itemValues.do_not_exchange) {
      item.validate(EXCHANGE_FEE).satisfies(rules.required);
    }

    if (itemValues.flat_exchange) {
      item.validate(CORE_REPAIR_FEE_NOT_TO_EXCEED).satisfies(rules.required);
    }
  }
  if (
    itemValues.exchange_srp &&
    props.minExchangeSrp &&
    !itemValues.do_not_exchange
  ) {
    item
      .validate(EXCHANGE_SRP)
      .satisfies(rules.isGreaterThanOrEqualTo(props.minExchangeSrp));
  } else if (itemValues.exchange_srp && !itemValues.do_not_exchange) {
    item.validate(EXCHANGE_SRP).satisfies(rules.isGreaterThan(0));
  }

  validateConditionFields(itemValues, item);
  validatePurchaseForFields(itemValues, item);
  validatePurchaseForSaleFields(itemValues, item);
};

export default function validate(values, props) {
  return validator(values, form => {
    form
      .validate(PAYMENT_TERMS, BUYING_STORE_ID, BUYER_CREDIT_PCT, FOB)
      .satisfies(rules.required);
    form.validateChildren(LINE_ITEMS, validateLineItem(props));
    validateShippingFields(values, form);
  });
}



// WEBPACK FOOTER //
// ./app/modules/IncomingQuotes/Detail/ConvertToPurchaseOrder/validate.js